import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import SVGInline from 'react-svg-inline';

import ArrowSVG from './img/arrow.svg';
import './Select.scss';

const b = block('select-mobile');

const Select = ({ items, onChange, placeholder = '', color = '', paginator, title = '' }) => {
  const locale = useSelector(state => state.locale.locale);
  const [isOpen, changeOpen] = useState(false);

  const itemsList = useMemo(
    () =>
      items.map(item => {
        const onItemChange = () => {
          const changedList = items.map(item2 => ({
            ...item2,
            active: item2.key === item.key,
          }));

          const checkHasActive = changedList.filter(item2 => item2.active);
          if (checkHasActive.length === 0) changedList[0].active = true;
          onChange(changedList);
          changeOpen(false);
        };

        return (
          <li key={item.value} className={b('item', { color, data: `${item.value}` })} onClick={onItemChange}>
            <div className={b('item-main')}>
              <span className={b('item-text')}>{item.renderElement}</span>
              {item.svg && <SVGInline className={b('item-icon').toString()} svg={item.svg} />}
            </div>
          </li>
        );
      }),
    [items, onChange, changeOpen, paginator, color],
  );

  const activeItem = useMemo(() => items.find(item => item.active) || items[0], [items]);

  return (
    <div
      className={b({ open: isOpen, color, paginator, withTitle: !!title })}
      onClick={() => changeOpen(!isOpen)}
      onMouseLeave={() => changeOpen(false)}>
      <div className={b('item', { current: true, color, data: `${activeItem.value}`  })}>
        <div className={b('item-text')}>
          {title && <span className={b('item-title')}>{title}</span>}
          {activeItem.selectedRenderElement}
        </div>
        <SVGInline className={b('arrow').toString()} svg={ArrowSVG} />
      </div>
      {isOpen && <ul className={b('items-list', { color })}>{itemsList}</ul>}
    </div>
  );
};

Select.propTypes = {
  items: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  color: PropTypes.string,

  onChange: PropTypes.func.isRequired,
};

export default Select;
